import React from "react";
import { EmptyResult } from "../organisation";
import OldResultItem from "./OldResultItem";
import { Order } from "../../store/slices/order/types";

const OldResultList = ({ oldOrder }: { oldOrder: Order | null }) => {
  return (
    <>
      <div className="">
        {oldOrder?.firstName && (
          <h1 className="mb-4 text-[#0C4654] font-semibold">
            Result(s) for {oldOrder?.firstName} {oldOrder?.lastName}
          </h1>
        )}
        <div>
          {oldOrder && oldOrder?.uploadedResultPdfs?.length > 0 ? (
            oldOrder?.uploadedResultPdfs?.map((oldResultItem) => (
              <OldResultItem
                key={oldResultItem?.id}
                oldResultItem={oldResultItem}
              />
            ))
          ) : (
            <EmptyResult showButton={false} />
          )}
        </div>
      </div>
    </>
  );
};

export default OldResultList;
